<template>
  <div class="animation-container">
    <div class="animation-text" v-html="currentText"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    clock: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      delayInterval: 0.2
    }
  },
  computed: {
    currentText () {
      let copy = this.text
      const copyArray = copy.split('</span>')
      const reverse = this.clock > this.duration - (1000 + (this.delayInterval * copyArray.length * 1000))
      for(let i = 0; i < copyArray.length; i++) {
        let formatted = `${copyArray[i]}</span></span>`
        formatted = formatted.replace(
          '<span>',
          `<span><span class="${ reverse ? 'fade-drop-out' : 'fade-drop'}" style="animation-delay: ${i * this.delayInterval}s">`
        )
        copyArray[i] = formatted
      }
      return copyArray.join('')
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';

.animation-container {
  ::v-deep .animation-text {
    > span {
      display: block;

      .fade-drop {
        transform: translateY(33%);
        opacity: 0;
        animation: fade-drop 1s $ease-expo 0s 1 normal forwards;
      }
      .fade-drop-out {
        animation: fade-drop-out 1s $ease-out-expo 0s 1 normal forwards;
      }
    }
    
    span {
      display: block;
    }
  }
}

@keyframes fade-drop {
  from {
    transform: translateY(25%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fade-drop-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-25%);
    opacity: 0;
  }
}
</style>
